module.exports = __webpack_public_path__ + "img/banner01_h5.6e12503d.webp";